import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
// import format from 'date-fns/format';
import LightBox from './LightBox';

const styles = theme => ({
  header: {
    padding: theme.spacing.unit * 2,
  },
  image: {
    width: '100%',
    objectFit: "cover",
    height: "400px"
  },
  content: {
    padding: theme.spacing.unit * 3,
  }
});

const Hero = props => {
  const { classes, title, lastUpdated, imageUrl, oneLiner } = props;
  return (
    <div>
      <header className={classes.header}>
        <Typography variant="h5">{title}</Typography>
        {lastUpdated && (
          <Typography variant="subtitle1">
            Last updated: {lastUpdated}
          </Typography>
        )}
      </header>
      <Paper>
        <LightBox 
          images={[imageUrl?imageUrl:"/img/na.png"]} 
          photoIndex={0} 
          clickable={
            <img 
              className={classes.image} 
              src={imageUrl?imageUrl:"/img/na.png"} 
              alt={title}
            />
          }
        />
        <Grid
          className={classes.content}
          container
          wrap="nowrap"
          justify="center"
          alignItems="center"
        >
          <Grid item>
            <Typography
              align="center"
              gutterBottom
              variant="body1"
            >
              {oneLiner}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};

Hero.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string,
  lastUpdated: PropTypes.string,
  imageUrl: PropTypes.string,
  oneLiner: PropTypes.string,
};

export default withStyles(styles)(Hero);
